import numberFormat from '@/filters/numberFormat'
export default {
  filters: {
    numberFormat
  },
  props: {
    content: {
      default: () => [],
      required: true,
      type: Array
    },
    openableDocuments: {
      default: () => [],
      required: true,
      type: Array
    },
    currencies: {
      default: () => {},
      required: true,
      type: Object
    },
    loading: {
      default: false,
      type: Boolean
    }
  },
  methods: {
    openDocument (document) {
      if (this.openableDocuments.indexOf(document.name) !== -1) {
        this.$router.push({ name: `balance/${document.name}`, params: { docId: document.doc_id } })
      }
    }
  }
}
